import React from "react";
import {RepairValue} from "../../gameplay/model/Balance";
export default class StateBar extends React.Component {
    constructor() {
        super();
        this.id = 0;
    }
    getEmptyBar(){
        let barStyle = {
            background: "#C4C4C4",
            width: `${5 * (this.props.scale ?? 1)}px`,
            height: `${10 * (this.props.scale ?? 1)}px`,
            border: `${1* (this.props.scale ?? 1)}px solid #C4C4C4`,
            boxSizing: "border-box"
        }
        return <div key={this.id} style={barStyle}/>
    }
    getGreenBar(isBright){
        let barStyle = {
            background: "#008C46",
            width: `${5 * (this.props.scale ?? 1)}px`,
            height: `${10 * (this.props.scale ?? 1)}px`
        }
        if(isBright){
            barStyle = {
                ...barStyle,
                filter: "brightness(2)"
            }
        }
        return <div key={this.id} style={barStyle}/>
    }
    getRedBar(isBright){
        let barStyle = {
            background: "#EE3124",
            width: `${5 * (this.props.scale ?? 1)}px`,
            height: `${10 * (this.props.scale ?? 1)}px`
        }
        if(isBright){
            barStyle = {
                ...barStyle,
                filter: "brightness(4)"
            }
        }
        return <div key={this.id} style={barStyle}/>
    }
    render() {
        let mainStyle = {
            display: "flex",
            justifyContent: "space-between",
            width: `${68 * (this.props.scale ?? 1)}px`
        }
        let state = this.props.state;
        let stateBars = [];
        for (let i = 0; i < RepairValue; i++){
            if(i >= state  + (this.props.forRepair ?? 0)){
                stateBars.push(this.getEmptyBar());
            }
            else {
                if(i < 4){
                    stateBars.push(this.getRedBar(i >= state));
                }
                else {
                    stateBars.push(this.getGreenBar(i >= state));
                }
            }
            this.id++;
        }
        return <div style={mainStyle}>
            {stateBars}
        </div>
    }
}
